// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Dropdown-DropdownToggle-module--cls1--qU9C7","cls2":"Dropdown-DropdownToggle-module--cls2--1Uqs3 Dropdown-DropdownToggle-module--cls1--qU9C7"};